import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import {
    AuthenticatedCanActivateChildGuard,
    AuthenticatedCanActivateGuard,
    AuthenticationTranslationsResolver,
    TranslationsResolver,
} from './core';

const routes: Routes = [
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    {
        path: 'dashboard',
        loadChildren: () => import('./modules/dashboard').then((m) => m.DashboardModule),
        canActivate: [AuthenticatedCanActivateGuard],
        canActivateChild: [AuthenticatedCanActivateChildGuard],
        resolve: { translationRequired: TranslationsResolver },
    },
    {
        path: 'authentication',
        loadChildren: () => import('./modules/authentication').then((m) => m.AuthenticationModule),
        resolve: { translationRequired: AuthenticationTranslationsResolver },
    },
    {
        path: '**',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
